import { Action } from 'redux';

import { OrderWithSamples } from '@models';

import { RequestStatus } from './request';

export const GOT_ORDERS = 'GOT_ORDERS';
export const GETTING_ORDERS = 'GETTING_ORDERS';

export interface IOrdersAction extends Action {
  payload: OrderWithSamples[];
}

export type OrdersActionsType = Action | IOrdersAction;

export interface IOrdersState {
  orders: OrderWithSamples[];
  status: RequestStatus;
}
